import { c as _c } from "react/compiler-runtime";
import { type UseQueryResult, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import type { Inventory } from '@libs/common-node';
import type { StoreSearchParams } from '@libs/common-types';
import { searchStores } from '../api';
import { enhanceStoresWithInventory } from '../libs';
import { useQueryInventoryPairs } from './use-query-inventory-pairs';
type StoreSku = {
  store: string;
  sku: string;
};
export const useStoreSearchQuery = t0 => {
  const $ = _c(38);
  let params;
  let sku;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      minimumCaseQty: t1,
      sku,
      enabled: t2,
      ...params
    } = t0);
    $[0] = t0;
    $[1] = params;
    $[2] = sku;
    $[3] = t1;
    $[4] = t2;
  } else {
    params = $[1];
    sku = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const minimumCaseQty = t1 === undefined ? 0 : t1;
  const enabled = t2 === undefined ? true : t2;
  let t3;
  if ($[5] !== params || $[6] !== sku) {
    t3 = ["storeSearch", sku, params];
    $[5] = params;
    $[6] = sku;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const queryKey = t3;
  let t4;
  if ($[8] !== params || $[9] !== sku) {
    t4 = () => searchStores({
      includeAttributes: Boolean(sku),
      ...params,
      sku
    });
    $[8] = params;
    $[9] = sku;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== enabled || $[12] !== queryKey || $[13] !== t4) {
    t5 = {
      queryKey,
      queryFn: t4,
      staleTime: 3600000,
      enabled
    };
    $[11] = enabled;
    $[12] = queryKey;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const searchQuery = useQuery(t5);
  let t6;
  if ($[15] !== enabled || $[16] !== searchQuery.data) {
    t6 = enabled ? searchQuery.data || [] : [];
    $[15] = enabled;
    $[16] = searchQuery.data;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const stores = t6;
  let t7;
  if ($[18] !== sku || $[19] !== stores) {
    t7 = sku ? stores.reduce((acc, store) => {
      if (store?.Store?.StoreNumber) {
        acc.push({
          store: `${store.Store.StoreNumber}`,
          sku: `${sku}`
        });
      }
      return acc;
    }, []) : [];
    $[18] = sku;
    $[19] = stores;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  const storesku = t7;
  const t8 = storesku.length > 0;
  let t9;
  if ($[21] !== t8) {
    t9 = {
      enabled: t8
    };
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== storesku || $[24] !== t9) {
    t10 = {
      storesku,
      options: t9
    };
    $[23] = storesku;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const inventoryQuery = useQueryInventoryPairs(t10) as UseQueryResult<Inventory[]>;
  let t11;
  if ($[26] !== inventoryQuery.data || $[27] !== sku) {
    t11 = (inventoryQuery.data || []).find(inventory => inventory.sku === String(sku)) ?? {} as Inventory;
    $[26] = inventoryQuery.data;
    $[27] = sku;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  const skuInventory = t11;
  const isLoading = !enabled || searchQuery.isPending || inventoryQuery.isLoading;
  const isError = searchQuery.isError || inventoryQuery.isError;
  let t12;
  if ($[29] !== isLoading || $[30] !== minimumCaseQty || $[31] !== skuInventory || $[32] !== stores) {
    t12 = isLoading ? stores : enhanceStoresWithInventory(skuInventory, stores, minimumCaseQty);
    $[29] = isLoading;
    $[30] = minimumCaseQty;
    $[31] = skuInventory;
    $[32] = stores;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  const enchancedStoreData = t12;
  let t13;
  if ($[34] !== enchancedStoreData || $[35] !== isError || $[36] !== isLoading) {
    t13 = {
      isLoading,
      isError,
      data: enchancedStoreData
    };
    $[34] = enchancedStoreData;
    $[35] = isError;
    $[36] = isLoading;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  return t13;
};